import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const getLessonQuestionsFunc = createAsyncThunk("questions/getByLessonId", async (lessonId) => {
  try {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    return await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/questions/getByLessonId/${lessonId}`,{
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    ).then((res) => res.json());
  } catch (error) {
    swal("Error", error, "info");
    return error;
  }
});

const getLessonQuestionsSlicer = createSlice({
  name: "get quessions By Lesson Id",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getLessonQuestionsFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLessonQuestionsFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(getLessonQuestionsFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "Data Feched Successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
      }
    });
  },
});

export default getLessonQuestionsSlicer.reducer;
